import url from 'url';

import PortfolioError from 'portfolio-shared/util/PortfolioError';
import {
  FC_UNEXPECTED_ERROR,
  FC_SERVER_UNREACHABLE,
} from 'portfolio-shared/util/faultCode';
import logger from 'portfolio-shared/util/logging';

function _getQueryParamString(params) {
  return url.format({ query: params });
}

function _createRequest(path, params, properties) {
  try {
    return new Request(path + _getQueryParamString(params), properties);
  } catch (e) {
    logger.error('error creating request', path, params, properties);
    throw e;
  }
}

// Underscore naming due to some weird Babel bug
class _ApiClient {
  constructor(getState, cookie) {
    ['get', 'post', 'put', 'patch', 'delete'].forEach(method => {
      this[method] = async (path, query = {}) => {
        const data = query.data;
        const params = query.params;
        const formData = query.formData;
        // prepend the user-provided serverAddress path to the API request
        // e.g. /catalog/assets => http://server:8090/catalog/assets
        let serverAddress = getState().auth.serverAddress;
        serverAddress = serverAddress ? serverAddress.toLowerCase() : '';
        const adjustedPath = path[0] !== '/' ? '/' + path : path;
        const resolvedPath = serverAddress + adjustedPath;

        if (!resolvedPath) {
          throw new Error(
            'API path not available. Perhaps the user did not supply?'
          );
        }

        let bodyData; // must be undefined or edge will throw exceptions for GET and HEAD requests.
        let headers = new Headers({});

        if (formData) {
          const _tempFormData = new FormData();
          Object.entries(formData).forEach(([key, value]) =>
            _tempFormData.append(key, value)
          );
          bodyData = _tempFormData;
        } else {
          // The reason for this else statement is that we need this content-type
          // NOT to be set when we have FormData attached, so that it generates
          // the correct multipart boundry header via fetch. All other portfolio
          // API calls require the json content type to be present.
          headers = new Headers({
            'Content-type': 'application/json',
          });
        }

        if (data) {
          bodyData = JSON.stringify(data);
        }

        const requestProperties = {
          method,
          headers,
          mode: 'same-origin',
          body: bodyData,
        };

        const req = _createRequest(resolvedPath, params, requestProperties);

        let error;
        const response = await fetch(req).catch(e => {
          error = new PortfolioError('network error', FC_SERVER_UNREACHABLE, {
            method: req.method,
            url: resolvedPath,
          });
        });
        if (error) {
          throw error;
        }
        let result = null;
        try {
          result = await response.json();
        } catch (e) {
          // Do nothing if the call to json() fails to parse
        }
        if (!response.ok) {
          const json = {
            faultCode: result
              ? result.faultCode || FC_UNEXPECTED_ERROR
              : FC_UNEXPECTED_ERROR,
            ...result,
          };
          const context = {
            method: req.method,
            httpStatus: response.status,
            url: response.url,
          };
          throw new PortfolioError(json.message, json.faultCode, context);
        }

        return result;
      };
    });
  }
}

export default _ApiClient;



// WEBPACK FOOTER //
// ./src/util/ApiClient.js